import React from 'react';

export function ActionDataColumnFormatter(cellContent) {
  return (
    <div>
      <div className={'text-dark-75 font-weight-bolder d-block font-size-lg'}>
        {cellContent?.page}
      </div>
      <div className={'font-weight-bold'}>{cellContent?.subject}</div>
      <div
        title={cellContent?.payload}
        style={{maxWidth: 400}}
      >
        {cellContent?.payload}
      </div>
    </div>
  );
}
